type RegionI18nMap = {[regionId: string]: I18nType<string>}
export let regionIdToUrlI18nMap: RegionI18nMap

export const setMap = (map: RegionI18nMap) => {
	regionIdToUrlI18nMap = map
}
